import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { Environment } from '../classes/environment';


@Injectable()
export class OfflineModeInterceptor implements HttpInterceptor {


	constructor(
		@Inject('environment') private environment: Environment,
	) {}


	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		
		if( !this.environment.offlineMode ) return next.handle(req);

		// assets
		if( !req.url.includes( 'http' ) ) return next.handle(req);

		return of( new HttpResponse({ body: null }) );

	}
}

